import React, { ChangeEventHandler } from "react";

type SwitchProps = {
  isToggle: boolean;
  handleToggle: ChangeEventHandler<HTMLInputElement>;
};

const Switch = ({ isToggle, handleToggle }: SwitchProps) => {
  // @ts-ignore
  return (
    <>
      <input
        checked={isToggle}
        onChange={handleToggle}
        className="switch-checkbox"
        id={`switch-new`}
        type="checkbox"
      />
      <label
        className={`switch-label ${isToggle ? "switch-label-on" : ""}`}
        htmlFor={`switch-new`}
      >
        <span className={`switch-button`} />
      </label>
    </>
  );
};

export default Switch;
